class RequiredHoursController {
  constructor($scope, $uibModalInstance) {
    "ngInject";
    this.$uibModalInstance = $uibModalInstance;
  }

  save() {
    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

}

export default RequiredHoursController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/required-hours/required-hours.controller.js